<template>
    <x-page title="Add SMS">
        <template #header-actions>
            <x-back-button :disabled="isLoading" />
        </template>
        <sms-form id="sms-form"
            @submit="handleSubmit"
            :disabled="isLoading"
            :errors="errors" />
        <template #footer>
            <x-submit-button form="sms-form"
                :is-loading="isLoading"
                :disabled="isLoading" />
        </template>
    </x-page>
</template>

<script>
import XBackButton from '../../components/XBackButton.vue'
import XPage from '../../components/XPage.vue'
import XSubmitButton from '../../components/XSubmitButton.vue'
import { handleValidationXhrError } from '../../helpers'
import SmsForm from './SmsForm.vue'

export default {
    components: {
        XPage,
        XBackButton,
        XSubmitButton,
        SmsForm,
    },
    data() {
        return {
            errors: null,
            isLoading: false,
        }
    },
    methods: {
        handleSubmit(fields) {
            this.isLoading = true
            const request = axios.post(`/api/sms`, fields)
                .then(() => {
                    this.$notify({
                        type: 'success',
                        title: `Berhasil`,
                        text: `${fields.title || 'SMS'} added!`,
                    })
                    this.$router.back()
                })
            return handleValidationXhrError(request, errors => {
                this.errors = errors
            }).finally(() => {
                this.isLoading = false
            })
        }
    },
}
</script>